import React from "react";
import Header from "./Header";
import TenantLogo from "./TenantLogo";
import BookLocationHeader from "../../bookLocation/common/util/BookLocationHeader";

interface PageShellProps {
  title: string;
  children: React.ReactNode;
}

/**
 * The standard chrome of a full-page screen: the tenant logo in the shared
 * Header on top, the page title in BookLocationHeader typography, and a
 * centered max-w-lg content column. `pb-28` clears the fixed bottom toolbar
 * (QA fix — do not remove).
 *
 * Extracted from AccountPageLayout, which now delegates to it: the same shell
 * is what the tab screens (OrdersPage / LocationSelectionPage) and the postpay
 * acceptance screen need, and a second copy of the markup is how two of them
 * drift apart.
 */
const PageShell: React.FC<PageShellProps> = ({ title, children }) => (
  <div className="mx-auto flex w-full max-w-lg flex-col px-6 pb-28">
    <Header>
      <TenantLogo />
    </Header>
    <div className="flex flex-col gap-6">
      <BookLocationHeader text={title} />
      {children}
    </div>
  </div>
);

export default PageShell;
